var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolgordeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.803,
    height: 21,
    viewBox: "0 0 14.803 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(-880.361 -226.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M13.592,17.159l5.6-5.6a1.053,1.053,0,0,1,1.494,0,1.067,1.067,0,0,1,0,1.5L14.341,19.4a1.056,1.056,0,0,1-1.459.031L6.5,13.06a1.058,1.058,0,0,1,1.494-1.5Z",
    transform: "translate(874.174 227.538)",
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-2",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M7.4,5.912,13,.311a1.053,1.053,0,0,1,1.494,0,1.067,1.067,0,0,1,0,1.5L8.153,8.156a1.056,1.056,0,0,1-1.459.031L.309,1.814A1.058,1.058,0,0,1,1.8.315Z",
    transform: "translate(895.164 234.712) rotate(180)",
    fill: "#bebebe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolgordeIcon);
export default __webpack_public_path__ + "static/media/volgorde-icon.309ef15f.svg";
export { ForwardRef as ReactComponent };